import { render, staticRenderFns } from "./RulesLogicStep.vue?vue&type=template&id=09c6603e&scoped=true"
import script from "./RulesLogicStep.vue?vue&type=script&lang=ts"
export * from "./RulesLogicStep.vue?vue&type=script&lang=ts"
import style0 from "./RulesLogicStep.vue?vue&type=style&index=0&id=09c6603e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c6603e",
  null
  
)

export default component.exports